<template>
  <HubContainer id="branchUsersHub">

    <HubSection large icon="icon/hub/dispatch.svg" v-if="atLeastSuperAdmin && moduleActivated.dispatch"
                :title="$t('roles.ROLE_DISPATCH')"
                :description="$t('roles.ROLE_DISPATCH_description')"
                :buttonAction="goToDispatch">
    </HubSection>

    <HubSection large icon="icon/hub/administrator.svg" v-if="atLeastSuperAdmin"
                :title="$t('roles.ROLE_BRANCH_ADMIN')"
                :description="$t('roles.ROLE_BRANCH_ADMIN_description')"
                :buttonAction="goToOrgAdmin">
    </HubSection>

    <HubSection large icon="icon/hub/commands.svg"
                :title="$t('roles.ROLE_RECEPTION')"
                :description="$t('roles.ROLE_RECEPTION_description')"
                :buttonAction="goToRecep">
    </HubSection>

  </HubContainer>
</template>

<script>
import HubSection from "@/components/HubSection";
import HubContainer from "@/components/HubContainer";

export default {
  name: "BranchUserHub",

  components: { HubSection, HubContainer },

  async mounted() {
    this.$store.state.pageTitleTranslationKey = "users.title";
    this.$store.state.pageIcon = "/icon/nav/users.svg";

    if (this.$route.query.branch) {
      let branchModule = await this.$store.getters.getContextBranchActivatedModule;
      Object.assign(this.moduleActivated, branchModule);
    }
    if (this.$route.query.company) {
      let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
      Object.assign(this.moduleActivated, companyModule);
    }
  },

  data() {
    return {
      moduleActivated: {
        onlineOrdering: false,
        kiosk: false,
        mobileApp: false,
        menuBoard: false,
        loyalty: false,
        thirdPartyLoyalty: false,
        aimsVouchers: false,
        onSiteOrdering: false,
        payAtTheTable: false,
        catering: false,
        dispatch: false,
        POS: false,
      }
    }
  },

  computed: {
    atLeastSuperAdmin() {
      return this.$store.getters.loggedUserHasSuperAdmin;
    },
  },

  methods: {
    goToOrgAdmin() {
      this.$router.push(this.$router.buildContext("/users/ROLE_ADMIN"));
    },
    goToDispatch() {
      this.$router.push(this.$router.buildContext("/users/ROLE_DISPATCH"));
    },
    goToRecep() {
      this.$router.push(this.$router.buildContext("/users/ROLE_RECEPTION"));
    }
  }
}
</script>